export default "__VITE_ASSET__dee73117__"